import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ff69501e")

_pushScopeId("data-v-ff69501e")
const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-6 p-mt-4 p-float-label" }
const _hoisted_3 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_4 = { class: "p-field p-col-6 p-mt-4 p-float-label" }
const _hoisted_5 = { class: "selected-options-container" }
const _hoisted_6 = {
  for: "threshold",
  class: "kn-material-input-label"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_ExectuteEtlCard = _resolveComponent("ExectuteEtlCard")
  const _component_ContextBrokerCard = _resolveComponent("ContextBrokerCard")
  const _component_SendMailCard = _resolveComponent("SendMailCard")
  const _component_Card = _resolveComponent("Card")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.$t('kpi.alert.addAction'),
    breakpoints: _ctx.addActionDialogDescriptor.dialog.breakpoints,
    style: _ctx.addActionDialogDescriptor.dialog.style,
    visible: _ctx.dialogVisible,
    modal: true,
    closable: false,
    class: "p-fluid kn-dialog--toolbar--primary",
    "data-test": "add-action-dialog"
  }, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-col-12" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('kpi.alert.addAction')), 1)
        ]),
        end: _withId(() => [
          _createVNode(_component_Button, {
            icon: "pi pi-save",
            class: "p-button-text p-button-rounded p-button-plain",
            disabled: _ctx.actionSaveButtonDisabled,
            onClick: _ctx.handleSave
          }, null, 8, ["disabled", "onClick"]),
          _createVNode(_component_Button, {
            icon: "pi pi-times",
            class: "p-button-text p-button-rounded p-button-plain",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
          })
        ]),
        _: 1
      })
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, [
          _createVNode(_component_Dropdown, {
            id: "type",
            class: "kn-material-input",
            modelValue: _ctx.action.idAction,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.action.idAction = $event)),
            dataKey: "id",
            optionLabel: "name",
            optionValue: "id",
            options: _ctx.actionList,
            onChange: _ctx.setType
          }, null, 8, ["modelValue", "options", "onChange"]),
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('kpi.alert.type')) + " * ", 1)
        ]),
        _createVNode("span", _hoisted_4, [
          _createVNode(_component_MultiSelect, {
            id: "threshold",
            class: "kn-material-input",
            modelValue: _ctx.selectedThresholds,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedThresholds = $event)),
            optionLabel: "label",
            options: _ctx.kpi.threshold?.thresholdValues
          }, {
            value: _withId((slotProps) => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(slotProps.value, (option) => {
                return (_openBlock(), _createBlock("div", {
                  class: "selected-options-container",
                  key: option.code
                }, [
                  _createVNode("div", {
                    class: "color-box",
                    style: { 'background-color': option.color }
                  }, null, 4),
                  _createTextVNode(" " + _toDisplayString(option.label), 1)
                ]))
              }), 128))
            ]),
            option: _withId((slotProps) => [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", {
                  class: "color-box",
                  style: { 'background-color': slotProps.option.color }
                }, null, 4),
                _createTextVNode(" " + _toDisplayString(slotProps.option.label), 1)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "options"]),
          _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('kpi.alert.threshold')) + " * ", 1)
        ])
      ]),
      _createVNode(_component_Card, { style: {"height":"37rem"} }, {
        content: _withId(() => [
          (_ctx.action && _ctx.action.className == 'it.eng.knowage.enterprise.tools.alert.action.ExecuteETLDocument')
            ? (_openBlock(), _createBlock(_component_ExectuteEtlCard, {
                key: 0,
                loading: _ctx.loading,
                files: _ctx.etlDocumentList,
                data: _ctx.action
              }, null, 8, ["loading", "files", "data"]))
            : _createCommentVNode("", true),
          (_ctx.action && _ctx.action.className == 'it.eng.spagobi.tools.alert.action.NotifyContextBroker')
            ? (_openBlock(), _createBlock(_component_ContextBrokerCard, {
                key: 1,
                data: _ctx.action
              }, null, 8, ["data"]))
            : (_ctx.action && _ctx.action.className == 'it.eng.knowage.enterprise.tools.alert.action.SendMail')
              ? (_openBlock(), _createBlock(_component_SendMailCard, {
                  key: 2,
                  action: _ctx.action,
                  users: _ctx.formatedUsers
                }, null, 8, ["action", "users"]))
              : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["header", "breakpoints", "style", "visible"]))
})